import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 0) {
        console.error('Network error:', error.message);
      } else if (error.status === 401 && !req.url.includes('/api/auth/')) {
        authService.currentUser.set(null);
      } else {
        console.error(`HTTP ${error.status}:`, error.message);
      }
      return throwError(() => error);
    }),
  );
};
